export default __webpack_public_path__ + "static/media/59.5642e46d.jpg";